import moment from 'moment-timezone';
import { Pipe, PipeTransform } from '@angular/core';
import { SessionService } from '../services/session.service';
import { CultureService } from '../../public-api';

@Pipe({
    name: 'localDate',
    standalone: false
})
export class localDatePipe implements PipeTransform {

  constructor(
    private cultureService: CultureService,
    private sessionService: SessionService
  ) {}

  transform(value: string | Date, compensateTimeZone: boolean = false): string {

    if (value === null || value === undefined || value === '') return null;

    var culture = this.cultureService.getCulture();
    var language = this.sessionService.getLanguage();

    if (language == null)
      console.error('localDate cannot be used when language == null.');

    const dte = moment.utc(value);

    if (compensateTimeZone) {
      return dte.tz(culture.TimeZone!).format(culture.FormatDate);
    }

    return dte.tz('UTC').format(culture.FormatDate);

  }
}
